<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-12">
          <h4>
            Select Site:
            <el-select
              class="select-primary tab"
              placeholder="Single Select"
              v-model="selects.selectSite"
              @change="filterSite()"
            >
              <el-option
                v-for="option in selects.site"
                class="select-primary"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </h4>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3">
          <!-- Percentage of Emission Oxygen (O2) gas -->
          <div class="row">
            <div class="col-lg">
              <card>
                <div class="row">
                  <div class="col-lg-12">
                    <pie-chart
                      v-if="o2.loaded"
                      :chart-data="o2.chartData"
                      :extra-options="o2.extraOptions"
                      :height="150"
                    ></pie-chart>
                    <div
                      class="justify-content-center spinner"
                      v-if="!o2.loaded"
                    >
                      <circle-8></circle-8>
                    </div>
                  </div>
                </div>
                <br />
                <div class="row text-center">
                  <div class="col-lg-12">
                    <!-- hmm -->
                    <h1 v-if="O2.value > O2.limit" style="color: red">
                      {{ O2.value }} %
                    </h1>
                    <h1 v-if="O2.value <= O2.limit">{{ O2.value }} %</h1>
                    <h1 v-else>{{ O2.value }} %</h1>

                    <h5 style="">
                      Percentage of Emission Oxygen (O<sub>2</sub>) gas
                    </h5>
                    <p style="font-size: 12px">
                      DOE CEMS Limit {{ O2.limit }} %
                    </p>
                  </div>
                </div>
              </card>
            </div>
          </div>
          <!-- Percentage of the Particles Opacity -->
          <div class="row">
            <div class="col-lg">
              <card>
                <div class="row">
                  <div class="col-lg-12">
                    <pie-chart
                      v-if="opacity.loaded"
                      :chart-data="opacity.chartData"
                      :extra-options="opacity.extraOptions"
                      :height="150"
                    ></pie-chart>
                    <div
                      class="justify-content-center spinner"
                      v-if="!opacity.loaded"
                    >
                      <circle-8></circle-8>
                    </div>
                  </div>
                </div>
                <br />
                <div class="row text-center">
                  <div class="col-lg-12">
                    <!-- hmm -->
                    <h1 v-if="OPACITY.value > OPACITY.limit" style="color: red">
                      {{ OPACITY.value }} %
                    </h1>
                    <h1 v-if="OPACITY.value <= OPACITY.limit">
                      {{ OPACITY.value }} %
                    </h1>

                    <h5 style="">
                      Percentage of the Particles Opacity
                    </h5>
                    <p style="font-size: 12px">
                      DOE CEMS Limit {{ OPACITY.limit }} %
                    </p>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="row">
            <div class="col-lg d-flex">
              <card class="custom-card">
                <div class="row">
                  <div class="col-lg-6"></div>
                  <div class="col-lg-6 text-right">
                    <h1 v-if="SO2.value > SO2.limit" style="color: red">
                      {{ SO2.value }}
                      <p style="font-size: 12px">mg/m3</p>
                    </h1>
                    <h1 v-if="SO2.value <= SO2.limit" >
                      {{ SO2.value }}
                      <p style="font-size: 12px">mg/m3</p>
                    </h1>
                  </div>
                </div>
                <div class="row card-line" style="">
                  <div class="col-lg"></div>
                </div>
                <div class="row">
                  <!-- v-html="card.footerTotalAsset" -->
                  <div class="col-lg">
                    <div
                      class="footer-font"
                      slot="footer"
                      style="color: #99e6ff"
                    >
                      SO<sub>2</sub>
                    </div>
                  </div>
                  <div class="col-lg text-right">
                    <p style="font-size: 12px">
                      DOE CEMS Limit<br />
                      {{ SO2.limit }} mg/m3
                    </p>
                  </div>
                </div>
              </card>
            </div>
            <div class="col-lg d-flex">
              <card class="custom-card">
                <div class="row">
                  <div class="col-lg-6"></div>
                  <div class="col-lg-6 text-right">
                    <h1 v-if="NOx.value > NOx.limit" style="color: red">
                      {{ NOx.value }}
                      <p style="font-size: 12px">mg/m3</p>
                    </h1>
                    <h1 v-if="NOx.value <= NOx.limit">
                      {{ NOx.value }}
                      <p style="font-size: 12px">mg/m3</p>
                    </h1>
                  </div>
                </div>
                <div class="row card-line" style="">
                  <div class="col-lg"></div>
                </div>
                <div class="row">
                  <div class="col-lg">
                    <div
                      class="footer-font"
                      slot="footer"
                      style="color: #99e6ff"
                    >
                      NO<sub>x</sub>
                    </div>
                  </div>
                  <div class="col-lg text-right">
                    <p style="font-size: 12px">
                      DOE CEMS Limit<br />
                      {{ NOx.limit }} mg/m3
                    </p>
                  </div>
                </div>
              </card>
            </div>
          </div>
          <div class="row">
            <div class="col-lg d-flex">
              <card class="custom-card">
                <div class="row">
                  <div class="col-lg-6"></div>
                  <div class="col-lg-6 text-right">
                    <h1 v-if="CO.value > CO.limit" style="color: red">
                      {{ CO.value }}
                      <p style="font-size: 12px">mg/m3</p>
                    </h1>
                    <h1 v-if="CO.value <= CO.limit">
                      {{ CO.value }}
                      <p style="font-size: 12px">mg/m3</p>
                    </h1>
                  </div>
                </div>
                <div class="row card-line" style="">
                  <div class="col-lg"></div>
                </div>
                <div class="row">
                  <div class="col-lg">
                    <div
                      class="footer-font"
                      slot="footer"
                      style="color: #99e6ff"
                    >
                      CO
                    </div>
                  </div>
                  <div class="col-lg text-right">
                    <p style="font-size: 12px">
                      DOE CEMS Limit<br />
                      {{ CO.limit }} mg/m3
                    </p>
                  </div>
                </div>
              </card>
            </div>
            <div class="col-lg d-flex">
              <card class="custom-card">
                <div class="row">
                  <div class="col-lg-6"></div>
                  <div class="col-lg-6 text-right">
                    <h1 v-if="HCL.value > HCL.limit" style="color: red">
                      {{ HCL.value }}
                      <p style="font-size: 12px">mg/m3</p>
                    </h1>
                    <h1 v-if="HCL.value <= HCL.limit">
                      {{ HCL.value }}
                      <p style="font-size: 12px">mg/m3</p>
                    </h1>
                  </div>
                </div>
                <div class="row card-line" style="">
                  <div class="col-lg"></div>
                </div>
                <div class="row">
                  <div class="col-lg">
                    <div
                      class="footer-font"
                      slot="footer"
                      style="color: #99e6ff"
                    >
                      HCL
                    </div>
                  </div>
                  <div class="col-lg text-right">
                    <p style="font-size: 12px">
                      DOE CEMS Limit<br />
                      {{ HCL.limit }} mg/m3
                    </p>
                  </div>
                </div>
              </card>
            </div>
          </div>
          <div class="row">
            <div class="col-lg d-flex">
              <card class="custom-card">
                <div class="row">
                  <div class="col-lg-6"></div>
                  <div class="col-lg-6 text-right">
                    <h1 v-if="HF.value > HF.limit" style="color: red">
                      {{ HF.value }}
                      <p style="font-size: 12px">mg/m3</p>
                    </h1>
                    <h1 v-if="HF.value <= HF.limit">
                      {{ HF.value }}
                      <p style="font-size: 12px">mg/m3</p>
                    </h1>
                  </div>
                </div>
                <div class="row card-line" style="">
                  <div class="col-lg"></div>
                </div>
                <div class="row">
                  <div class="col-lg">
                    <div
                      class="footer-font"
                      slot="footer"
                      style="color: #99e6ff"
                    >
                      HF
                    </div>
                  </div>
                  <div class="col-lg text-right">
                    <p style="font-size: 12px">
                      DOE CEMS Limit<br />
                      {{ HF.limit }} mg/m3
                    </p>
                  </div>
                </div>
              </card>
            </div>
            <div class="col-lg d-flex">
              <card class="custom-card">
                <div class="row">
                  <div class="col-lg-6"></div>
                  <div class="col-lg-6 text-right">
                    <h1 v-if="NMVOC.value > NMVOC.limit" style="color: red">
                      {{ NMVOC.value }}
                      <p style="font-size: 12px">mg/m3</p>
                    </h1>
                    <h1 v-if="NMVOC.value <= NMVOC.limit">
                      {{ NMVOC.value }}
                      <p style="font-size: 12px">mg/m3</p>
                    </h1>
                  </div>
                </div>
                <div class="row card-line" style="">
                  <div class="col-lg"></div>
                </div>
                <div class="row">
                  <div class="col-lg">
                    <div
                      class="footer-font"
                      slot="footer"
                      style="color: #99e6ff"
                    >
                      NMVOC
                    </div>
                  </div>
                  <div class="col-lg text-right">
                    <p style="font-size: 12px">
                      DOE CEMS Limit<br />
                      {{ NMVOC.limit }} mg/m3
                    </p>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
        <div class="col-lg-3 d-flex">
          <card>
            <div class="row text-center">
              <div class="col-lg">
                <h4>Total Particulate Metal (TPM)</h4>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-lg text-center" style="padding-top: 50%">
                <h1 v-if="TOTALPM.value > TOTALPM.limit" style="color: red">
                  {{ TOTALPM.value }}
                  <p style="font-size: 12px">mg/m3</p>
                </h1>
                <h1 v-if="TOTALPM.value <= TOTALPM.limit">
                  {{ TOTALPM.value }}
                  <p style="font-size: 12px">mg/m3</p>
                </h1>
              </div>
              <div class="col-lg-7 text-center">
                <bar-chart
                  v-if="totalpm.loaded"
                  :chart-data="totalpm.chartData"
                  :extra-options="totalpm.extraOptions"
                  :gradient-colors="totalpm.gradientColors"
                  :gradient-stops="totalpm.gradientStops"
                  :height="505"
                ></bar-chart>
              </div>
           
            </div>
            <br />
            
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  TabPane,
  Tabs,
  Collapse,
  CollapseItem,
  BaseProgress,
  Modal,
  BaseSwitch,
  BaseCheckbox,
} from "src/components";
import { Table, TableColumn, DatePicker, Select, Option } from "element-ui";
import StatsCard from "src/components/Cards/StatsCard";
import BarChart from "@/components/Charts/BarChart";
import LineChart from "@/components/Charts/LineChart";
import PieChart from "src/components/Charts/PieChart";
import config from "@/config";
import * as chartConfigs from "@/components/Charts/config";

import { Circle8 } from "vue-loading-spinner";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";

export default {
  components: {
    Loading,
    TabPane,
    Tabs,
    Collapse,
    CollapseItem,
    StatsCard,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    BaseProgress,
    PieChart,
    LineChart,
    BarChart,
    Modal,
    BaseSwitch,
    BaseCheckbox,
    Circle8,
  },
  data() {
    return {
      SO2: {
        value: 52,
        limit: 50,
      },
      NOx: {
        value: 36.72,
        limit: 200,
      },
      CO: {
        value: 20.216,
        limit: 50,
      },
      HCL: {
        value: 0.0,
        limit: 40,
      },
      O2: {
        value: 13.762,
        limit: "N/A",
      },
      HF: {
        value: 0.0021,
        limit: 1,
      },
      NMVOC: {
        value: 100.0,
        limit: 10,
      },
      OPACITY: {
        value: 23.17,
        limit: 20,
      },
      TOTALPM: {
        value: 28.851,
        limit: 100,
      },
      tableData: [],
      selects: {
        selectSite: "",
        site: [{ value: "*", label: "All" }],
       
      },
      o2: {
        chartData: {
          labels: ["Percentage of Emission Oxygen (O2) gas"],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: ["#3282b8"],
              borderWidth: 0,
              data: [13.7, 86.3],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.pieChartOptions2,
      },
      opacity: {
        chartData: {
          labels: ["Percentage of the Particles Opacity"],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: ["#52de97"],
              borderWidth: 0,
              data: [23.17, 76.83],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.pieChartOptions2,
      },
      totalpm: {
        chartData: {
          labels: [""],
          datasets: [
            {
              label: "Total PM",
              backgroundColor: "#ffcc00",
              data: [28.851],
            },
            {
              label: "Limit",
              backgroundColor: "#fa163f",
              data: [100],
            },
          ],
        },
        loaded: true,
        extraOptions: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: true,
            labels: {
                fontColor: "#FFFFFF"
            }
            
          },
          animation: {
            // onComplete: () => {
            //   delayed = true;
            // },
            // delay: (context) => {
            //   let delay = 0;
            //   if (
            //     context.type === "data" &&
            //     context.mode === "default" &&
            //     !delayed
            //   ) {
            //     delay = context.dataIndex * 300 + context.datasetIndex * 100;
            //   }
            //   return delay;
            // },
          },
          scales: {
            xAxes: [
              {
                // stacked: true,
                categoryPercentage: 0.5,
                barPercentage: 0.6,
                gridLines: {
                  drawBorder: false,
                  color: "transparent",
                  zeroLineColor: "transparent",
                },
              },
            ],
            yAxes: [
              {
                // stacked: true,
                gridLines: {
                  drawBorder: false,
                  color: "transparent",
                  zeroLineColor: "transparent",
                },
                ticks: {
                  suggestedMin: 0,
                  suggestedMax: 100,
                  padding: 20,
                  fontColor: "transparent",
                },
              },
            ],
          },
        },
        gradientColors: [
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.1)",
        ],
        gradientStops: [1, 0],
      },
    };
  },

  created() {
    this.getSite()
    
    // this.getReminder();
    
    //temp worker
  },
  beforeDestroy() {
    console.log("SOCKS_CLOSED");
    this.socket.close();
  },

  methods: {
    getSite(){
      this.selects.site = []

      this.$http.get(":9997/api/v1/setting/plant"). 
      then(res => {
        if(!res.error){
          let response = res.message
          console.log(response)

          for(var i=0; i<response.length; i++){
            let obj = {
              label: response[i].PlantName,
              value: response[i].PlantID
            }

            this.selects.site.push(obj)
          }

          this.selects.selectSite = this.selects.site[0].value;
          this.getSocketData();
        }
      })
      // this.selects.selectSite = []
    },
    // tableRowClassName({ rowIndex }) {
    //   let currentETD = moment(this.tableData[rowIndex].NextMaintenanceDate);
    //   if (currentETD < moment.now()) {
    //     return "table-red";
    //   }
    //   return "";
    // },
    // tableRowClassReminder({ rowIndex }) {
    //   if (this.tableReminder[rowIndex].IsDue === 1) {
    //     return "table-red";
    //   }
    //   return "";
    // },
    // getReminder() {
    //   this.$http.get(":9996/api/v1/mobile/reminder").then((res) => {
    //     if (!res.error) {
    //       let data = res.message;
    //       console.log(data);
    //       if (data.length != 0) {
    //         // this.modals.etdNotification = true;
    //         this.modals.etdNotification = false;
    //         this.tableReminder = data;
    //       }
    //     }
    //   });
    // },
    filterSite() {
      this.socket.close();
    
      this.getSocketData();
    },
    getSocketData() {
      // console.log(this.selects.selectSite)
      this.socket = new WebSocket(
        process.env.VUE_APP_WS_URL + ":9997/api/v1/ws/cems/" + this.selects.selectSite
      );
      this.socket.onopen = () => {
        this.status = "connected";
        let currentFilter = [this.selects.selectSite];
        this.socket.send(currentFilter);
        this.isLoading = true;
      };
      this.socket.onmessage = ({ data }) => {
        // console.log(this.selects.selectSite);
        this.parseData(data);
      };
      return this.socket;
    },
    parseData(data){
      console.log(JSON.parse(data))

      let a = JSON.parse(data)

      // Percentage of Emission Oxygen (O2) gas
      this.o2 = {
        chartData: {
          labels: ["Percentage of Emission Oxygen (O2) gas"],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: ["#3282b8"],
              borderWidth: 0,
              data: [a.O2, 100 - a.O2 ],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.pieChartOptions2,
      },

      this.O2.value = a.O2
      this.O2.limit = a.O2_threshold

      // Percentage of Emission Oxygen (O2) gas
      this.opacity = {
        chartData: {
          labels: ["Percentage of the Particles Opacity"],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: ["#52de97"],
              borderWidth: 0,
              data: [a.Opacity, 100 - a.Opacity],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.pieChartOptions2,
      },

      this.OPACITY.value = a.Opacity
      this.OPACITY.limit = 20

      // SO2
      this.SO2.value = a.So2
      this.SO2.limit = a.So2_threshold

      // NOX
      this.NOx.value = a.No2
      this.NOx.limit = a.No2_threshold

      // CO
      this.CO.value = a.Co
      this.CO.limit = a.Co_threshold

      // HL
      this.HCL.value = a.Hcl
      this.HCL.limit = a.Hcl_threshold

      // HF
      this.HF.value = a.Hf
      this.HF.limit = a.Hf_threshold
      
      // NMVOC
      this.NMVOC.value = a.Nvmoc
      this.NMVOC.limit = a.Nvmoc_threshold

      // TOTAL PM
      this.totalpm = {
        chartData: {
          labels: [""],
          datasets: [
            {
              label: "Total PM",
              backgroundColor: "#ffcc00",
              data: [a.TOTAL_PM],
            },
            {
              label: "Limit",
              backgroundColor: "#fa163f",
              data: [a.TOTAL_PM_threshold],
            },
          ],
        },
        loaded: true,
        extraOptions: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: true,
            labels: {
                fontColor: "#FFFFFF"
            }
            
          },
          scales: {
            xAxes: [
              {
                // stacked: true,
                categoryPercentage: 0.5,
                barPercentage: 0.6,
                gridLines: {
                  drawBorder: false,
                  color: "transparent",
                  zeroLineColor: "transparent",
                },
              },
            ],
            yAxes: [
              {
                // stacked: true,
                gridLines: {
                  drawBorder: false,
                  color: "transparent",
                  zeroLineColor: "transparent",
                },
                ticks: {
                  suggestedMin: 0,
                  suggestedMax: 100,
                  padding: 20,
                  fontColor: "transparent",
                },
              },
            ],
          },
        },
        gradientColors: [
          "rgba(255, 3, 2, 0.8)",
          "rgba(255, 3, 2, 0.2)",
          "rgba(255, 3, 2, 0.1)",
        ],
        gradientStops: [1, 0],
      }

      this.TOTALPM.value = a.TOTAL_PM
      this.TOTALPM.limit = a.TOTAL_PM_threshold
    }
    // parseData(data) {
    //   this.selects.site = [{ value: "*", label: "All" }];
    //   this.utilizationGraph.loaded = false;
    //   this.ppmStatus.loaded = false;
    //   this.assetOwnership.loaded = false;
    //   console.log("CALLED PARSE");
    //   console.log(data);
    //   let jsonData = JSON.parse(data);
    //   console.log(jsonData);
    //   // ################# FILTER ################# //
    //   let filter = jsonData.Filter;
    //   for (let i = 0; i < filter.length; i++) {
    //     let siteFilter = {
    //       value: filter[i].SiteID,
    //       label: filter[i].SiteName,
    //     };
    //     this.selects.site.push(siteFilter);
    //   }
    //   // ################# CARD ################# //
    //   // console.log(jsonData.Card.AssetUtilization)
    //   // this.statsCard1[0].title = jsonData.Card.TotalAsset.toString();
    //   // // this.percent.utilization = jsonData.Card.AssetUtilization.toString();
    //   // this.statsCard1[1].title = jsonData.Card.DhesAsset.toString();
    //   // this.statsCard1[2].title = jsonData.Card.ContractorAsset.toString();
    //   // this.statsCard1[3].title = jsonData.Card.PpmDone.toString();
    //   // this.statsCard1[4].title = jsonData.Card.PpmMaintenance.toString();
    //   // this.statsCard2[0].title = jsonData.Card.PpmOverdue.toString();
    //   // this.statsCard2[1].title = jsonData.Card.Breakdown.toString();
    //   // this.statsCard2[2].title = jsonData.Card.UnderRepair.toString();
    //   // this.statsCard2[3].title = jsonData.Card.ProposedBer.toString();
    //   // this.statsCard2[4].title = jsonData.Card.NonOperational.toString();
    //   this.card = {
    //     // total assets
    //     titleTotalAsset: jsonData.Card.TotalAsset.toString(),
    //     iconTotalAsset: require("@/assets/img/asset_total.png"),
    //     footerTotalAsset: "Total Assets",
    //     // DHES asset
    //     titleDHESAsset: jsonData.Card.DhesAsset.toString(),
    //     iconDHESAsset: require("@/assets/img/asset_total_DHES.png"),
    //     footerDHESAsset: "AFES Asset",
    //     // Contractor asset
    //     titleContractor: jsonData.Card.ContractorAsset.toString(),
    //     iconContractor: require("@/assets/img/asset_total_contractor.png"),
    //     footerContractor: "Contractor Asset",
    //     // PPM Done
    //     titlePPMDone: jsonData.Card.PpmDone.toString(),
    //     iconPPMDone: require("@/assets/img/Done.png"),
    //     footerPPMDone: "PPM Done",
    //     // PPM Under-maintenance
    //     titleUndermaintenance: jsonData.Card.PpmMaintenance.toString(),
    //     iconUndermaintenance: require("@/assets/img/service_maintenance.png"),
    //     footerUndermaintenance: "Under-maintenance",
    //     // PPM Overdue
    //     titlePPMOverdue: jsonData.Card.PpmOverdue.toString(),
    //     iconPPMOverdue: require("@/assets/img/overdue.png"),
    //     footerPPMOverdue: "PPM Overdue",
    //     // Breakdown
    //     titleBreakdown: jsonData.Card.Breakdown.toString(),
    //     iconBreakdown: require("@/assets/img/breakdown.png"),
    //     footerBreakdown: "Breakdown",
    //     // Under-repair
    //     titleUnderrepair: jsonData.Card.UnderRepair.toString(),
    //     iconUnderrepair: require("@/assets/img/service_maintenance.png"),
    //     footerUnderrepair: "Under-Repair",
    //     // Proposed-BER
    //     titleProposedber: jsonData.Card.ProposedBer.toString(),
    //     iconProposedber: require("@/assets/img/Non-repairable .png"),
    //     footerProposedber: "Proposed-BER",
    //     // Available
    //     titleAvailable: jsonData.Card.NonOperational.toString(),
    //     iconAvailable: require("@/assets/img/Done.png"),
    //     footerAvailable: "Available",
    //     // Operational
    //     titleOperational: jsonData.Card.Operational.toString(),
    //     iconOperational: require("@/assets/img/operational.png"),
    //     footerOperational: "Operational",
    //   };
    //   // ################# ASSET PERCENTAGE ################# //
    //   this.percent.dhesAsset = parseFloat(
    //     ((jsonData.Card.DhesAsset / jsonData.Card.TotalAsset) * 100).toFixed(2)
    //   );
    //   this.percent.contractorAsset = parseFloat(
    //     (
    //       (jsonData.Card.ContractorAsset / jsonData.Card.TotalAsset) *
    //       100
    //     ).toFixed(2)
    //   );
    //   this.percent.ppmDone = parseFloat(
    //     ((jsonData.Card.PpmDone / jsonData.Card.TotalAsset) * 100).toFixed(2)
    //   );
    //   this.percent.ppmMaintain = parseFloat(
    //     (
    //       (jsonData.Card.PpmMaintenance / jsonData.Card.TotalAsset) *
    //       100
    //     ).toFixed(2)
    //   );
    //   this.percent.ppmDue = parseFloat(
    //     ((jsonData.Card.PpmOverdue / jsonData.Card.TotalAsset) * 100).toFixed(2)
    //   );
    //   this.percent.utilization = parseFloat(
    //     jsonData.Card.AssetUtilization
    //   ).toFixed(2);
    //   this.percent.breakdown = parseFloat(
    //     ((jsonData.Card.Breakdown / jsonData.Card.TotalAsset) * 100).toFixed(2)
    //   );
    //   this.percent.underrepair = parseFloat(
    //     ((jsonData.Card.UnderRepair / jsonData.Card.TotalAsset) * 100).toFixed(
    //       2
    //     )
    //   );
    //   this.percent.proposedber = parseFloat(
    //     ((jsonData.Card.ProposedBer / jsonData.Card.TotalAsset) * 100).toFixed(
    //       2
    //     )
    //   );
    //   this.percent.available = parseFloat(
    //     (
    //       (jsonData.Card.NonOperational / jsonData.Card.TotalAsset) *
    //       100
    //     ).toFixed(2)
    //   );
    //   if (jsonData.Card.TotalAsset == 0) {
    //     this.percent.available = parseFloat(0).toFixed(2);
    //     this.percent.proposedber = parseFloat(0).toFixed(2);
    //     this.percent.underrepair = parseFloat(0).toFixed(2);
    //     this.percent.breakdown = parseFloat(0).toFixed(2);
    //     this.percent.ppmDue = parseFloat(0).toFixed(2);
    //     this.percent.ppmMaintain = parseFloat(0).toFixed(2);
    //     this.percent.ppmDone = parseFloat(0).toFixed(2);
    //     this.percent.contractorAsset = parseFloat(0).toFixed(2);
    //     this.percent.dhesAsset = parseFloat(0).toFixed(2);
    //   }
    //   // ################# ASSET OWNERSHIP ################# //
    //   let newAssetOwner = {
    //     chartData: {
    //       labels: ["AFES", "Contractor"],
    //       datasets: [
    //         {
    //           pointRadius: 0,
    //           pointHoverRadius: 0,
    //           backgroundColor: ["#336fb6", "#f9f6f7"],
    //           borderWidth: 0,
    //           data: [jsonData.Card.DhesAsset, jsonData.Card.ContractorAsset],
    //         },
    //       ],
    //     },
    //     extraOptions: chartConfigs.pieChartOptions,
    //     loaded: true,
    //   };
    //   this.assetOwnership = newAssetOwner;
    //   // ################# PPM STATUS ################# //
    //   let newPPMStatus = {
    //     chartData: {
    //       labels: ["Done", "Under Maintenance", "Overdue"],
    //       datasets: [
    //         {
    //           pointRadius: 0,
    //           pointHoverRadius: 0,
    //           backgroundColor: ["#84eb3d", "#fcf305", "red"],
    //           borderWidth: 0,
    //           data: [
    //             jsonData.Card.PpmDone,
    //             jsonData.Card.PpmMaintenance,
    //             jsonData.Card.PpmOverdue,
    //           ],
    //         },
    //       ],
    //     },
    //     extraOptions: chartConfigs.pieChartOptions,
    //     loaded: true,
    //   };
    //   this.ppmStatus = newPPMStatus;
    //   // ################# ASSET UTILIZATION ################# //
    //   let graph = jsonData.Graph;
    //   let timeStamp = [];
    //   let utilData = [];
    //   for (let i = 0; i < graph.length; i++) {
    //     timeStamp.push(moment(graph[i].Date).format("YYYY-MM-DD"));
    //     utilData.push(graph[i].AssetUtilization);
    //   }
    //   this.updateGraph(timeStamp, utilData);
    //   // ################# TABLE ################# //
    //   console.log(jsonData.table);
    //   this.tableData = jsonData.table;
    // },
    // async updateGraph(timeStamp, data) {
    //   let newAssetUtil = await {
    //     chartData: {
    //       labels: timeStamp,
    //       datasets: [
    //         {
    //           label: "Asset Utilization",
    //           fill: true,
    //           borderColor: "rgba(211, 244, 255, 1)",
    //           borderWidth: 2,
    //           borderDash: [],
    //           borderDashOffset: 0.0,
    //           pointBackgroundColor: "rgba(211, 244, 255, 1)",
    //           pointBorderColor: "rgba(255,255,255,0)",
    //           pointHoverBackgroundColor: "#be55ed",
    //           pointBorderWidth: 20,
    //           pointHoverRadius: 4,
    //           pointHoverBorderWidth: 15,
    //           pointRadius: 4,
    //           data: data,
    //         },
    //       ],
    //     },
    //     extraOptions: chartConfigs.percentChartOptions,
    //     gradientColors: [
    //       "rgba(211, 244, 255, 0.8)",
    //       "rgba(211, 244, 255, 0.3)",
    //       "rgba(211, 244, 255, 0.0)",
    //     ],
    //     gradientStops: [1, 0.4, 0],
    //     loaded: true,
    //   };
    //   console.log(newAssetUtil);
    //   this.utilizationGraph = newAssetUtil;
    // },
  },
};
</script>
<style lang="scss" scoped>
.footer-font {
  font-size: 110%;
}
.tab {
  margin-left: 1%;
  margin-right: 1%;
}
.test {
  width: 800px;
}
.dialog {
  margin-left: 30%;
}
.spinner {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.card-line {
  border-top: 0.5px solid #2b3553;
  margin: 5px;
}

.custom-card {
  height: 205px;
  padding-top: 5%;
}
</style>
